import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import ApiService from "@/core/services/ApiService";
import {
  WhiteLabel,
  WhiteLabelDocument,
} from "@/core/services/api/interfaces/manager/WhiteLabel";
import { PaginationResponse } from "@/core/services/api/interfaces/PaginationResponse";

@Module
export default class WhiteLabelModule extends VuexModule {
  _whiteLabel: WhiteLabel | null = null;
  _documents: PaginationResponse<WhiteLabelDocument> = new PaginationResponse();

  get whiteLabel(): WhiteLabel | null {
    return this._whiteLabel;
  }

  get whiteLabelDocuments(): PaginationResponse<WhiteLabelDocument> {
    return this._documents;
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_WHITE_LABEL_LOAD]() {
    if (
      !this.context.getters.isIndividualOrHas2FA ||
      !this.context.getters.isUserCompanyEnabled
    ) {
      return;
    }
    return ApiService.manager.company.white_label
      .view()
      .then(ApiService.unwrapItemResponse<WhiteLabel>)
      .then((whiteLabel) => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_WHITE_LABEL_SET,
          whiteLabel
        );

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_COMPANY_WHITE_LABEL_LOAD
        );
      });
  }

  @Action({ rawError: true })
  async [Actions.MANAGER_COMPANY_WHITE_LABEL_UPDATE](data) {
    return ApiService.manager.company.white_label
      .update(data)
      .then(ApiService.unwrapItemResponse<WhiteLabel>)
      .then((whiteLabel) => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_WHITE_LABEL_SET,
          whiteLabel
        );
      });
  }

  @Action({ rawError: true })
  async [Actions.MANAGER_COMPANY_WHITE_LABEL_DOCUMENT_UPDATE](data) {
    return ApiService.manager.company.white_label.documents
      .update(data)
      .then(ApiService.unwrapPaginationResponse<WhiteLabelDocument>)
      .then((documents) => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_SET,
          documents
        );
      });
  }

  @Action({ rawError: true })
  async [Actions.MANAGER_COMPANY_WHITE_LABEL_DOCUMENT_IMAGE_UPLOAD]({
    document_type,
    column,
    image,
  }) {
    return ApiService.manager.company.white_label.documents
      .uploadImage(document_type, column, image)
      .then(ApiService.unwrapPaginationResponse<WhiteLabelDocument>)
      .then((documents) => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_SET,
          documents
        );
      });
  }

  @Action({ rawError: true })
  async [Actions.MANAGER_COMPANY_WHITE_LABEL_IMAGE_UPLOAD]({ column, image }) {
    return ApiService.manager.company.white_label
      .uploadImage(column, image)
      .then(ApiService.unwrapItemResponse<WhiteLabel>)
      .then((whiteLabel) => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_WHITE_LABEL_SET,
          whiteLabel
        );
      });
  }

  @Action({ rawError: true })
  [Actions.MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_LOAD]() {
    if (
      !this.context.getters.isIndividualOrHas2FA ||
      !this.context.getters.isUserCompanyEnabled
    ) {
      return;
    }
    return ApiService.manager.company.white_label.documents
      .list()
      .then(ApiService.unwrapPaginationResponse<WhiteLabel>)
      .then((documents) => {
        this.context.commit(
          Mutations.MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_SET,
          documents
        );

        this.context.commit(
          Mutations.COMMON_REQUEST_DONE,
          Actions.MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_LOAD
        );
      });
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_WHITE_LABEL_SET](whiteLabel: WhiteLabel) {
    this._whiteLabel = whiteLabel;
  }

  @Mutation
  [Mutations.MANAGER_COMPANY_WHITE_LABEL_DOCUMENTS_SET](
    documents: PaginationResponse<WhiteLabelDocument>
  ) {
    this._documents = documents;
  }
}
